<template>
    <article class="prize-aside" :class="`prize-aside--${gridLayout} prize-aside--${hasShadow}`">
        <h2 class="prize-aside__title">{{ title }}</h2>
        <ul class="prize-aside__prizes">
            <template v-for="(prize, index) in activePrizes">
                <PrizeSmall
                    :key="index"
                    :prizeTitle="prize.reference"
                    :quantity="prize.quantity"
                    :value="prize.unitValue"
                    :image="prize.image"
                />
            </template>
        </ul>
        <SccLink class="prize-aside__link" to="#prize-list">
            {{ linkText }}
        </SccLink>
    </article>
</template>

<script>
import './prize-aside.scss';
import cloneDeep from 'lodash/cloneDeep';

import SccLink from '../global/SccLink';
import PrizeSmall from './PrizeSmall';

export default {
    name: 'PrizeAside',
    components: { SccLink, PrizeSmall },
    __editor: {
        requiredData: ['drawings'],
        fields: {
            gridLayout: {
                widget: 'select',
                values: ['span-1', 'span-2', 'span-3'],
            },
            hasShadow: {
                widget: 'select',
                values: ['has-shadow', 'no-shadow'],
            },
            title: {
                widget: 'text',
            },
            linkText: {
                widget: 'text',
            },
        },
    },
    props: {
        gridLayout: {
            type: String,
            default: 'span-2',
        },
        hasShadow: {
            type: String,
            default: 'no-shadow',
        },
        title: {
            type: String,
            default: 'Prizes title',
        },
        linkText: {
            type: String,
            default: 'Prizes link text',
        },
        drawings: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    computed: {
        activePrizes() {
            const allDrawings = cloneDeep(this.drawings);
            // Order drawing by closeAt param
            const sortedDrawings = allDrawings.sort((a, b) => {
                return new Date(b.closeAt) - new Date(a.closeAt);
            });
            // Return first drawing with open sales period
            const nextDrawing = sortedDrawings.find(drawing => {
                return new Date(drawing.closeAt) > new Date();
            });

            const drawing = nextDrawing || sortedDrawings[sortedDrawings.length - 1];

            return drawing?.prizes?.slice(0, 5);
        },
    },
};
</script>
